
// 경고페이지 설정
//
// @since 2018-03
// @author 강정규 ( devp012 )

export const state = () => ({
  url: '/api/sm/warning-pages',
  warningPageDataList: [],
  selectedItem: {},
  warningPageData: {
    name: '', //   required (string - maxLength: 32) 경고페이지 이름
    desc: '', //   (string) 설명
    type: 0, //  required (one of 0, 1) 경고페이지 동작 방식 (재지정 페이지: 0, 사용자 정의 경고페이지: 1)
    cntn: '', //   required (string) 재지정 페이지 타입일 경우 maxLength: 50, 사용자 지정 타입일 경우 maxLength: 1200
    cntn0: '', //  재지정 페이지일 경우 입력값
    cntn1: '' //   사용자 지정일 경우 입력값
  }
})

export const mutations = {
  // 경고 페이지 리스트 조회
  getWarningPage: (state, item) => {
    state.warningPageDataList = item
  },
  addWarningPage: (state, item) => {
    state.warningPageDataList.push(item)
  },
  edtWarningPage: (state, item) => {
    state.warningPageDataList.splice(state.selectedItem.itemIndex, 1, item)
  },
  delWarningPage: (state, itemIndexList) => {
    itemIndexList = itemIndexList.sort().reverse()
    for (const itemIndex of itemIndexList) {
      state.warningPageDataList.splice(itemIndex, 1)
    }
  },
  // 다이얼로그 타이틀, 버튼 변경
  setWarningPageDialog: (state, data) => {
    state.selectedItem = data
    state.warningPageData.name = data.name
    state.warningPageData.desc = data.desc
    state.warningPageData.type = data.type
    if (data.type === 0) {
      state.warningPageData.cntn0 = data.cntn
      state.warningPageData.cntn1 = ''
    } else {
      state.warningPageData.cntn1 = data.cntn
      state.warningPageData.cntn0 = ''
    }
  },
  clearWarningPageDialog: (state) => {
    state.warningPageData.name = ''
    state.warningPageData.desc = ''
    state.warningPageData.type = 0
    state.warningPageData.cntn = ''
    state.warningPageData.cntn0 = ''
    state.warningPageData.cntn1 = ''
  }
}

export const actions = {
  // 경고 페이지 리스트 조회
  async getWarningPage ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.url)
    if (code === 'ok') {
      commit('getWarningPage', result)
      return true
    }
    return false
  },
  async addWarningPage ({commit, state}, continued) {
    if (state.warningPageData.type === 0) {
      state.warningPageData.cntn = state.warningPageData.cntn0
    } else {
      state.warningPageData.cntn = state.warningPageData.cntn1
    }
    const {code, result} = await this.$axios.$post(state.url, state.warningPageData)

    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('addWarningPage', result)

      if (!continued) {
        commit('clearWarningPageDialog')
      }
      return true
    }
    return false
  },
  async edtWarningPage ({commit, state}) {
    const url = `${state.url}/${state.selectedItem.warn_page_id}`

    if (state.warningPageData.type === 0) {
      state.warningPageData.cntn = state.warningPageData.cntn0
    } else {
      state.warningPageData.cntn = state.warningPageData.cntn1
    }
    const {code, result} = await this.$axios.$put(url, state.warningPageData)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('edtWarningPage', result)
      return true
    }
    return false
  },
  async delWarningPage ({commit, state}, param) {
    const {code} = await this.$axios.$delete(state.url, {data: param.idList})
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('delWarningPage', param.itemIndexList)
      return true
    }
    return false
  },
  async finalCommand ({commit, state}, type) {
    let param = {}
    if (type === 'apply') {
      param = { applyMsg: true }
    } else {
      param = { cancelMsg: true }
    }
    const {code} = await this.$axios.$put(`${state.url}/${type}`, null, param)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    }
    return false
  }
}

export const getters = {
  getTest () {
    return 1
  }
}

export const strict = false
